import { Phone, Mail, MapPin } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { label: "Home", hash: "#home" },
  { label: "About Us", hash: "#about" },
  { label: "Products", hash: "#products" },
  { label: "Certificate", hash: "#certificate" },
  { label: "Contact Us", hash: "#contact" },
];

const Footer = () => {
  return (
    <footer data-testid="footer" className="relative bg-forest-deep grain overflow-hidden">
      <div className="relative z-10 px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto pt-16 sm:pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <span className="w-16 h-16 rounded-full bg-white ring-1 ring-gold/50 overflow-hidden">
                <img
                  src="/assets/nesha-logo.png"
                  alt="Nesha Global Pvt Ltd logo"
                  className="w-full h-full object-cover"
                />
              </span>
              <div>
                <p className="font-display text-2xl tracking-[0.18em] text-cream uppercase">
                  Nesha Global
                </p>
                <p className="font-mono text-[10px] tracking-[0.35em] text-gold uppercase">
                  Where Vision Meets The World
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/55">
              Premium global food sourcing and logistics from Dehradun, India —
              delivering agricultural commodities with quality, sustainability,
              integrity and precision.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.35em] text-sunset uppercase">
              Navigate
            </p>
            <nav className="mt-5 flex flex-col items-start gap-3">
              {LINKS.map((l) => (
                <button
                  key={l.hash}
                  data-testid={`footer-link-${l.hash.slice(1)}`}
                  onClick={() => scrollToSection(l.hash)}
                  className="font-grotesk text-sm text-cream/70 hover:text-gold transition-colors duration-300"
                >
                  {l.label}
                </button>
              ))}
              <a
                data-testid="footer-catalogue-link"
                href={`${process.env.REACT_APP_BACKEND_URL}/api/catalogue`}
                className="font-grotesk text-sm text-cream/70 hover:text-gold transition-colors duration-300"
              >
                Product Catalogue (PDF)
              </a>
            </nav>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono text-[10px] tracking-[0.35em] text-sunset uppercase">
              Reach Us
            </p>
            <div className="mt-5 space-y-4 text-sm">
              <a
                data-testid="footer-phone-link"
                href="tel:+916398888926"
                className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors duration-300"
              >
                <Phone className="w-4 h-4 text-gold" /> +91 6398888926
              </a>
              <a
                data-testid="footer-email-link"
                href="mailto:info@neshaglobal.com"
                className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors duration-300"
              >
                <Mail className="w-4 h-4 text-gold" /> info@neshaglobal.com
              </a>
              <p className="flex items-start gap-3 text-cream/70 leading-relaxed">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-gold" />
                Langha Road, Vikasnagar, C/O Amit Kumar Chharba, Sahaspur,
                Dehradun — 248197, Uttarakhand, India
              </p>
            </div>
          </div>
        </div>

        <p
          aria-hidden="true"
          className="mt-16 font-display uppercase text-[13vw] lg:text-[10vw] leading-none text-center select-none text-stroke-gold"
        >
          Nesha Global
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-cream/10 pt-6">
          <p className="font-mono text-[10px] tracking-[0.2em] text-cream/40 uppercase">
            © 2026 Nesha Global Pvt. Ltd. All rights reserved.
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] text-cream/40 uppercase">
            CIN — U46309UT2026PTC022410
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
